import { FormModal } from '../../Form'

import {
  REQUEST_EDIT_STATUS_MODAL_QA_NAME,
  REQUEST_EDIT_STATUS_MODAL_QA_NAME_SUBMIT_BTN,
} from './RequestEditStatusModal.constants'
import {
  getRequestEditStatusModalSubmitPayload,
  getRequestEditStatusValidationSchema,
} from './RequestEditStatusModal.utils'
import { RequestEditStatusModalFields } from './RequestEditStatusModalFields'

import * as styles from './RequestEditStatusModal.module.css'

function RequestEditStatusModal({
  Fields = RequestEditStatusModalFields,
  containerProps,
  getPayload = getRequestEditStatusModalSubmitPayload,
  initialValues,
  needToCheckNoChanges = true,
  onSubmit,
  ...restProps
}) {
  const validationSchema = getRequestEditStatusValidationSchema(
    initialValues,
    needToCheckNoChanges
  )

  function handleSubmit({ values }) {
    onSubmit({
      payload: getPayload(values),
      values,
    })
  }

  return (
    <FormModal
      {...restProps}
      withNotifications
      Fields={Fields}
      containerProps={{
        ...containerProps,
        confirmationProps: {
          className: styles.confirmationModal,
        },
        qaName: REQUEST_EDIT_STATUS_MODAL_QA_NAME,
      }}
      formBodyProps={{
        submitQaName: REQUEST_EDIT_STATUS_MODAL_QA_NAME_SUBMIT_BTN,
        withNotifications: true,
      }}
      formTitle='Modal.ChangeStatusTitleKey'
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={handleSubmit}
    />
  )
}

export default RequestEditStatusModal
